__turbopack_context__.v({
  "aboutCard": "interviewArticle-module-scss-module__52FKfW__aboutCard",
  "aboutColumn": "interviewArticle-module-scss-module__52FKfW__aboutColumn",
  "aboutCompany": "interviewArticle-module-scss-module__52FKfW__aboutCompany",
  "aboutDescription": "interviewArticle-module-scss-module__52FKfW__aboutDescription",
  "aboutTitle": "interviewArticle-module-scss-module__52FKfW__aboutTitle",
  "accordionSlideOverwrite": "interviewArticle-module-scss-module__52FKfW__accordionSlideOverwrite",
  "articleColumn": "interviewArticle-module-scss-module__52FKfW__articleColumn",
  "articleContent": "interviewArticle-module-scss-module__52FKfW__articleContent",
  "contentContainer": "interviewArticle-module-scss-module__52FKfW__contentContainer",
  "fadeIn": "interviewArticle-module-scss-module__52FKfW__fadeIn",
  "fadeOut": "interviewArticle-module-scss-module__52FKfW__fadeOut",
  "highlight": "interviewArticle-module-scss-module__52FKfW__highlight",
  "interviewArticle": "interviewArticle-module-scss-module__52FKfW__interviewArticle",
  "scaleIn": "interviewArticle-module-scss-module__52FKfW__scaleIn",
  "scaleOut": "interviewArticle-module-scss-module__52FKfW__scaleOut",
  "speakerBlock": "interviewArticle-module-scss-module__52FKfW__speakerBlock",
  "speakerList": "interviewArticle-module-scss-module__52FKfW__speakerList",
  "zoomIn": "interviewArticle-module-scss-module__52FKfW__zoomIn",
  "zoomOut": "interviewArticle-module-scss-module__52FKfW__zoomOut",
});
